import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import { FormRefContext } from 'features/global/context/FormRefContext';

import Button from '../../../../layout/components/Button';

import ArrowLeft from '../styles/images/arrow-left.svg';

import '../../../styles/skip-and-next-buttons.scss';

interface SkipAndNextButtonsProps {
  next: string;
  back?: string;
  submitLabel?: string;
  submitDisabled?: boolean;
  onSubmitClick?: () => void;
  formId?: string;
}

const SkipAndNextButtons: React.FC<SkipAndNextButtonsProps> = ({
  next,
  back,
  submitLabel = 'Save',
  submitDisabled = false,
  onSubmitClick = () => {},
  formId,
}) => {
  const { setSkipOrBack } = useContext(FormRefContext);

  return (
    <div className="skip-and-next">
      <NavLink
        to={next}
        className={'skip-btn'}
        onClick={() => setSkipOrBack(true)}
        data-testid="skip-button">
        Skip
      </NavLink>
      {back ? (
        <NavLink
          to={back}
          className={'back-btn'}
          onClick={() => setSkipOrBack(true)}
          data-testid="back-button">
          <img src={ArrowLeft} alt="arrowLeft" />
          Back
        </NavLink>
      ) : null}
      <Button
        className="next-btn"
        disabled={submitDisabled}
        type="submit"
        onClick={() => (onSubmitClick ? onSubmitClick() : undefined)}
        data-testid="submit-button"
        form={formId}>
        {submitLabel}
      </Button>
    </div>
  );
};

export default SkipAndNextButtons;
